import React, { Fragment, useEffect } from "react";
import { graphql, Link } from "gatsby";
import Seo from "gatsby-plugin-wpgraphql-seo";
import { Layout, Sidebar } from "../components";
import Moment from "react-moment";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Breadcrumb from "../components/Breadcrumb";

const SinglePost = ({
  title,
  data: {
    wpPost,
    wpPost: { featuredImage, date, linkedCategories },
    allWpCategory: { nodes },
    relatedPosts,
  },
}) => {
  const blogImage = getImage(
    featuredImage?.node?.localFile?.childImageSharp?.gatsbyImageData
  );

  useEffect(() => {
    // Set the font size of each <li> to match the font size of its first child element
    document.querySelectorAll("ol > li").forEach((li) => {
      const firstChild = li.firstElementChild;
      if (firstChild) {
        const computedFontSize = window.getComputedStyle(firstChild).fontSize;
        li.style.fontSize = computedFontSize;
      }
    });
  }, []);

  return (
    <>
      <Seo post={wpPost} />
      <Layout>
        <GatsbyImage image={blogImage} alt="" />
        <Breadcrumb />
        <section className="bg-white py-16">
          <div className="container mx-auto">
            <div className="flex flex-wrap">
              <div className="w-full basis-full px-4 lg:w-3/4 lg:basis-3/4">
                <h1 className="mb-8 w-full basis-full font-openSans text-4xl capitalize text-secondary">
                  {wpPost.title}
                </h1>
                <Moment
                  format="MMMM DD, YYYY"
                  className="mb-4 inline-block font-openSans text-2xl"
                >
                  {date}
                </Moment>
                {linkedCategories.nodes.length > 0 && (
                  <Fragment>
                    {" | "}
                    <Link
                      to={linkedCategories.nodes[0].uri}
                      className="mb-4 inline-block font-openSans text-2xl"
                    >
                      {linkedCategories.nodes[0].name}
                    </Link>
                  </Fragment>
                )}
                <div
                  className="post-content mb-12 w-full basis-full text-black"
                  dangerouslySetInnerHTML={{ __html: wpPost.content }}
                ></div>
                <h3 className="mb-4 font-openSans text-3xl text-secondary">
                  Related Articles
                </h3>
                <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-2 lg:mb-0">
                  {relatedPosts.posts?.nodes
                    ?.sort(() => Math.random() - 0.5)
                    .slice(0, 2)
                    .map((post, index) => {
                      const image = getImage(
                        post?.featuredImage?.node?.localFile?.childImageSharp
                          ?.gatsbyImageData
                      );
                      return (
                        <div className="w-full basis-full" key={index}>
                          <Link to={post.uri}>
                            <GatsbyImage image={image} alt="" />
                          </Link>
                          <Link
                            to={post.uri}
                            className="mt-4 inline-block font-openSans text-lg"
                          >
                            {post.title}
                          </Link>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="w-full basis-full px-4 lg:w-1/4 lg:basis-1/4">
                <Sidebar categories={nodes} />
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default SinglePost;

export const query = graphql`
  query SinglePostQuery($id: Int, $categoryId: Int) {
    allWpCategory(filter: { count: { gt: 0 } }) {
      nodes {
        uri
        name
      }
    }
    wpPost(databaseId: { eq: $id }) {
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
      date(formatString: "")
      title
      content
      featuredImage {
        node {
          localFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
            }
          }
        }
      }
      linkedCategories: categories {
        nodes {
          name
          uri
        }
      }
    }
    relatedPosts: wpCategory(databaseId: { eq: $categoryId }) {
      posts {
        nodes {
          title
          uri
          featuredImage {
            node {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
          }
        }
      }
    }
  }
`;
